<template>

    <main class="gmp-page gmp-page--no-newsletter">

        <DIS_scondHero />
        <DIS_highLights :clientWidth="clientWidth"/>
        <DIS_twoTout />

        <div>Distributor</div>

    </main>

</template>


<script>
    import DIS_scondHero from "../../components/content/market/overView/DIS_scondHero";
    import DIS_highLights from "../../components/content/market/overView/DIS_highLights";
    import DIS_twoTout from "../../components/content/market/overView/DIS_twoTout";


    export default {
        name: 'Distributor',
        components: {
            DIS_scondHero,
            DIS_highLights,
            DIS_twoTout,
        },
        data() {
            return {
                clientWidth: "",
            }
        },

        mounted() {

            this.clientWidth = `${document.documentElement.clientWidth}`          //document.body.clientWidth;
            const that = this
            window.onresize = () => {
                return (() => {
                    window.screenWidth = document.body.clientWidth
                    that.clientWidth = window.screenWidth
                })()
            }

        },
        methods: {

        }

    }
</script>

<style>


</style>
